/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceStatusListRequestBody
 */
export interface DeviceStatusListRequestBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeviceStatusListRequestBody
     */
    devices: Array<number>;
}

export function DeviceStatusListRequestBodyFromJSON(json: any): DeviceStatusListRequestBody {
    return DeviceStatusListRequestBodyFromJSONTyped(json, false);
}

export function DeviceStatusListRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceStatusListRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'devices': json['devices'],
    };
}

export function DeviceStatusListRequestBodyToJSON(value?: DeviceStatusListRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'devices': value.devices,
    };
}

